/* src/components/admin/announcements/dashboard/ReadReceiptsModal.js */
import React, { useEffect, useState } from "react";
import { subscribeReadsList } from "../AdminAnnouncementsLogic";
import { FiX, FiEye } from "react-icons/fi";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../firebaseConfig";
import "./ReadReceiptsModal.css";

function fmtReadTime(ms) {
  if (!ms) return "";
  const d = new Date(ms);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
    + " at "
    + d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

export default function ReadReceiptsModal({ announcement, onClose }) {
  const [rawRows, setRawRows] = useState([]);
  const [displayRows, setDisplayRows] = useState([]);
  const [enriching, setEnriching] = useState(false);

  useEffect(() => {
    const unsub = subscribeReadsList(announcement.id, (r) => setRawRows(r || []));
    return () => unsub?.();
  }, [announcement.id]);

  useEffect(() => {
    let alive = true;
    if (!rawRows || rawRows.length === 0) {
      setDisplayRows([]);
      return;
    }
    setEnriching(true);
    (async () => {
      const enriched = await Promise.all(
        rawRows.map(async (row) => {
          if (row.userName && row.userEmail) return row;
          try {
            const snap = await getDoc(doc(db, "users", row.uid));
            if (snap.exists()) {
              const d = snap.data();
              return { ...row, userName: d.name || "Unknown", userEmail: d.email || "" };
            }
          } catch (_) {}
          return { ...row, userName: "Unknown", userEmail: "" };
        })
      );
      if (alive) {
        setDisplayRows(enriched);
        setEnriching(false);
      }
    })();
    return () => { alive = false; };
  }, [rawRows]);

  return (
    <div className="rrBackdrop" onMouseDown={onClose}>
      <div className="rrModal" onMouseDown={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="rrHeader">
          <div className="rrHeaderLeft">
            <FiEye size={15} className="rrHeaderIcon" />
            <div>
              <div className="rrHeaderTitle">Read Receipts</div>
              <div className="rrHeaderSub" title={announcement.title || "(Untitled)"}>
                {announcement.title || "(Untitled)"}
              </div>
            </div>
          </div>
          <div className="rrHeaderRight">
            {displayRows.length > 0 && (
              <span className="rrCount">{displayRows.length} read</span>
            )}
            <button className="rrCloseBtn" onClick={onClose} type="button" aria-label="Close">
              <FiX size={16} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="rrBody">
          {enriching && displayRows.length === 0 ? (
            <div className="rrEmpty">Loading…</div>
          ) : displayRows.length === 0 ? (
            <div className="rrEmpty">
              <FiEye size={28} style={{ color: "#d4d4d8", marginBottom: 10 }} />
              <div>No one has read this announcement yet.</div>
            </div>
          ) : (
            <div className="rrList">
              {displayRows.map((r) => (
                <div key={r.id || r.uid} className="rrRow">
                  <div className="rrAvatar">
                    {(r.userName || r.userEmail || "U").slice(0, 1).toUpperCase()}
                  </div>
                  <div className="rrMeta">
                    <div className="rrName">{r.userName || "Unknown"}</div>
                    <div className="rrEmail">{r.userEmail || ""}</div>
                  </div>
                  <div className="rrTime">{fmtReadTime(r.readAtMs || r.readAt)}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="rrFooter">
          <button className="rrCloseFullBtn" onClick={onClose} type="button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
